import React from 'react';

import { Grid } from '@mantine/core';
import { IconPhone } from '@tabler/icons-react';
import { useSubscriptionContext } from 'contexts/SubscriptionContext';
import { CaldotcomIcon } from 'icons/Caldotcom';
import { FacebookIcon } from 'icons/FacebookIcon';
import { GoogleDriveIcon } from 'icons/GoogleDriveIcon';
import { InstagramIcon } from 'icons/InstagramIcon';
import { WhatsAppIcon } from 'icons/WhatsAppIcon';
import { ZapierIcon } from 'icons/ZapierIcon';
import { IntegrationCard } from 'pages/Settings/SettingTabs/IntegrationsSettingsTab/IntegrationCard';
import { IntegrationSettingTab } from 'pages/Settings/SettingTabs/IntegrationsSettingsTab/IntegrationSettingTab';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { IntegrationType } from 'shared/enums/integration';

export function IntegrationsSettingsTab() {
  const { t } = useTranslation();
  const location = useLocation();
  const { type } = queryString.parse(location.search);

  const [subscription] = useSubscriptionContext();

  const integrations = [
    {
      icon: <ZapierIcon h={18} w={18} />,
      title: t('ZAPIER.TITLE'),
      description: t('ZAPIER.DESCRIPTION'),
      type: IntegrationType.ZAPIER,
      isNew: false,
      isPreview: false,
      isAccessible: subscription.product.enableZapierAccess
    },
    {
      icon: <GoogleDriveIcon h={18} w={18} />,
      title: t('GOOGLE_DRIVE.TITLE'),
      description: t('GOOGLE_DRIVE.DESCRIPTION'),
      type: IntegrationType.GOOGLE_DRIVE,
      isNew: false,
      isPreview: false,
      isAccessible: subscription.product.enableGoogleDrive
    },
    {
      icon: <IconPhone style={{ height: 20, width: 20 }} />,
      title: t('PHONE_NUMBER.TITLE'),
      description: t('PHONE_NUMBER.DESCRIPTION'),
      type: IntegrationType.PHONE_NUMBER,
      isNew: false,
      isPreview: false,
      isAccessible: true
    },
    {
      icon: <WhatsAppIcon h={18} w={18} />,
      title: t('WHATSAPP.TITLE'),
      description: t('WHATSAPP.DESCRIPTION'),
      type: IntegrationType.WHATSAPP,
      isNew: false,
      isPreview: false,
      isAccessible: subscription.product.enableWhatsApp
    },
    {
      icon: <FacebookIcon h={18} w={18} />,
      title: t('FACEBOOK.TITLE'),
      description: t('FACEBOOK.DESCRIPTION'),
      type: IntegrationType.FACEBOOK,
      isNew: false,
      isPreview: false,
      isAccessible: subscription.product.enableFacebook
    },
    {
      icon: <InstagramIcon h={18} w={18} />,
      title: t('INSTAGRAM.TITLE'),
      description: t('INSTAGRAM.DESCRIPTION'),
      type: IntegrationType.INSTAGRAM,
      isNew: false,
      isPreview: false,
      isAccessible: subscription.product.enableInstagram
    },
    {
      icon: <CaldotcomIcon h={18} w={18} />,
      title: t('CALDOTCOM.TITLE'),
      description: t('CALDOTCOM.DESCRIPTION'),
      type: IntegrationType.CALDOTCOM,
      isNew: false,
      isPreview: false,
      isAccessible: true
    }
  ];

  return type ? (
    <IntegrationSettingTab />
  ) : (
    <Grid m={0} pt="sm">
      {integrations.map((item, key: number) => {
        return (
          <Grid.Col span="content" key={key}>
            <IntegrationCard
              title={item.title}
              description={item.description}
              icon={item.icon}
              isNew={item.isNew ?? false}
              isPreview={item.isPreview}
              isAccessible={item.isAccessible}
              type={item.type}
            />
          </Grid.Col>
        );
      })}
    </Grid>
  );
}
